import React, { createContext, useEffect, useState } from 'react';

import { notificationsList } from '../pages/NotificationPage/notificationContent';

const NotificationContext = createContext(undefined);

function NotificationProvider({ children }) {
  const [areAllNotificationsSeen, setAreAllNotificationsSeen] = useState(true);

  useEffect(() => {
    const numberOfNotificationsFromSession = window.localStorage.getItem(
      'notifications',
    );

    //numbers dont match show red dot on alarm
    if (
      numberOfNotificationsFromSession &&
      numberOfNotificationsFromSession !== notificationsList.length.toString()
    ) {
      setAreAllNotificationsSeen(false);
    }

    if (
      numberOfNotificationsFromSession === null &&
      notificationsList.length > 0
    ) {
      setAreAllNotificationsSeen(false);
    }
  }, []);

  return (
    <NotificationContext.Provider
      displayName="NotificationContext"
      value={{
        areAllNotificationsSeen,
        setAreAllNotificationsSeen,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
}

export { NotificationContext, NotificationProvider };
